import { styled } from "styled-components";

export const StyledWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.lg};
  color: ${({ theme }) => theme.colors.secondary};

  h1 {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.secondary};
  }

  h2 {
    font-size: 1.5rem;
    font-weight: bold;
    text-decoration: underline;
    margin-top: 2rem;
    margin-bottom: 0.75rem;
    color: ${({ theme }) => theme.colors.secondary};
  }

  h3 {
    font-size: 1.25rem;
    font-weight: bold;
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.colors.secondary};
  }

  p {
    font-size: 1rem;
    line-height: 1.7;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.secondary};
  }

  ul,
  ol {
    padding-left: 1.5rem;
    margin-bottom: 1rem;

    li {
      margin-bottom: 0.5rem;
    }
  }

  img {
    max-width: 100%;
    border-radius: 8px;
    margin: 1rem 0;
  }

  video {
    width: 100%;
    border-radius: 8px;
    margin: 1rem 0;
  }

  code {
    background-color: #d7d7d7;
    padding: 0.2em 0.4em;
    border-radius: 4px;
    font-size: 0.9em;
    font-family: monospace;
  }

  pre {
    background-color: #d7d7d7;
    padding: 1rem;
    border-radius: 6px;
    overflow-x: auto;
    font-size: 0.9rem;
    line-height: 1.5;
    font-family: monospace;
  }

  a {
    color: ${({ theme }) => theme.colors.link};
    text-decoration: underline;

    &:hover {
      color: ${({ theme }) => theme.colors.linkHover};
    }
  }

  .prompt {
    background-color: #e0f2fe;
    border-left: 4px solid #38bdf8;
    padding: 1rem;
    border-radius: 6px;
    margin: 1.5rem 0;
    font-size: 0.95rem;
    color: #0369a1;
  }

  .html-content {
    padding: 1rem;
    background-color: #f9fafb;
    border: 1px dashed #d1d5db;
    border-radius: 6px;
    margin: 1.5rem 0;

    p {
      margin-bottom: 0.75rem;
    }

    code {
      background: #f3f4f6;
      color: #111827;
    }
  }
`;
